// src/pages/Godown/DispatchModal.jsx
import { useState } from 'react';
import './ManageOrderModal.css';

const TRANSPORT_OPTIONS = [
  { value: '',              label: 'Select Transport' },
  { value: 'BLUE_DART',     label: 'Blue Dart' },
  { value: 'DTDC',          label: 'DTDC' },
  { value: 'DELHIVERY',     label: 'Delhivery' },
  { value: 'SELF_DELIVERY', label: 'Self Delivery' },
];

const DispatchModal = ({ order, onClose, onSubmit }) => {
  const [transportVia, setTransportVia] = useState('');
  const [notes,        setNotes]        = useState('');
  const [submitting,   setSubmitting]   = useState(false);
 const [error, setError] = useState('');

  // Initialize dispatch quantities from pending
  const [dispatches, setDispatches] = useState(
  order.items.map(item => {
    // ✅ Fallback: if pendingUnits/Boxes are null, derive from ordered - dispatched
    const pendingUnits = item.pendingUnits ?? Math.max(0, (item.orderedUnits || 0) - (item.dispatchedUnits || 0));
    const pendingBoxes = item.pendingBoxes ?? Math.max(0, (item.orderedBoxes || 0) - (item.dispatchedBoxes || 0));

    return {
      orderItemId:     item.id,
      dispatchUnits:   pendingUnits,
      dispatchBoxes:   pendingBoxes,
      productName:     item.product?.productName || '—',
      orderedUnits:    item.orderedUnits || 0,
      orderedBoxes:    item.orderedBoxes || 0,
      pendingUnits,
      pendingBoxes,
      dispatchedUnits: item.dispatchedUnits || 0,
      dispatchedBoxes: item.dispatchedBoxes || 0,
    };
  })
);

 const updateDispatch = (index, field, value) => {
  setDispatches(prev => {
    const updated = [...prev];
    const max = field === 'dispatchUnits'
      ? updated[index].pendingUnits
      : updated[index].pendingBoxes;
    const parsed = parseInt(value);
    const safe   = isNaN(parsed) ? 0 : parsed;
    updated[index] = {
      ...updated[index],
      [field]: Math.max(0, Math.min(safe, max)),
    };
    return updated;
  });
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Only include items with actual dispatch quantity
    const validDispatches = dispatches.filter(
      d => d.dispatchUnits > 0 || d.dispatchBoxes > 0
    );

    if (validDispatches.length === 0) {
      setError('Please enter dispatch quantity for at least one item');
  return;
    }

    setSubmitting(true);
    try {
      await onSubmit({
        dispatches: validDispatches.map(d => ({
          orderItemId:   d.orderItemId,
          dispatchUnits: d.dispatchUnits,
          dispatchBoxes: d.dispatchBoxes,
        })),
        transportVia: transportVia || undefined,
        notes:        notes || undefined,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content dispatch-modal" onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <div>
            <h4 className="modal-title">Dispatch Order — {order.orderId}</h4>
            <p style={{ fontSize: 13, color: '#6c757d', margin: '4px 0 0 0' }}>
              Dealer: {order.dealer?.dealerShopName}
            </p>
          </div>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">

            {/* Transport */}
            <div className="form-group">
              <label className="form-label">Transport Via</label>
              <select
                className="form-input"
                value={transportVia}
                onChange={e => setTransportVia(e.target.value)}
              >
                {TRANSPORT_OPTIONS.map(o => (
                  <option key={o.value} value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>

            {/* Items dispatch table */}
            <div style={{ marginTop: 16 }}>
              <p style={{ fontSize: 13, fontWeight: 600, color: '#495057', marginBottom: 12 }}>
                Dispatch Quantities
                <span style={{ fontSize: 11, color: '#6c757d', fontWeight: 400, marginLeft: 8 }}>
                  (Edit to dispatch partially — remaining stays pending)
                </span>
              </p>

              {dispatches.map((d, index) => (
                <div key={d.orderItemId} className="dispatch-item">
                  <div className="dispatch-item-name">{d.productName}</div>

                  <div className="dispatch-progress">
                    <span className="dp-label">Already dispatched:</span>
                    {d.dispatchedUnits > 0 && (
                      <span className="dp-val dispatched">{d.dispatchedUnits} units</span>
                    )}
                    {d.dispatchedBoxes > 0 && (
                      <span className="dp-val dispatched">{d.dispatchedBoxes} boxes</span>
                    )}
                    {d.dispatchedUnits === 0 && d.dispatchedBoxes === 0 && (
                      <span className="dp-val" style={{ color: '#adb5bd' }}>None yet</span>
                    )}
                  </div>

                  <div className="dispatch-progress">
                    <span className="dp-label">Pending:</span>
                    {d.orderedUnits > 0 && (
                      <span className="dp-val pending">{d.pendingUnits} units</span>
                    )}
                    {d.orderedBoxes > 0 && (
                      <span className="dp-val pending">{d.pendingBoxes} boxes</span>
                    )}
                  </div>

                  <div className="dispatch-inputs">
                    {d.orderedUnits > 0 && (
                      <div className="dispatch-input-group">
                        <label>Dispatch Units (max {d.pendingUnits})</label>
                        <input
                          type="number"
                          className="quantity-input"
                          value={d.dispatchUnits}
                          onChange={e => updateDispatch(index, 'dispatchUnits', e.target.value)}
                          min="0"
                          max={d.pendingUnits}
                        />
                      </div>
                    )}
                    {d.orderedBoxes > 0 && (
                      <div className="dispatch-input-group">
                        <label>Dispatch Boxes (max {d.pendingBoxes})</label>
                        <input
                          type="number"
                          className="quantity-input"
                          value={d.dispatchBoxes}
                          onChange={e => updateDispatch(index, 'dispatchBoxes', e.target.value)}
                          min="0"
                          max={d.pendingBoxes}
                        />
                      </div>
                    )}
                  </div>

                  {/* Remaining after this dispatch */}
                  <div className="dispatch-remaining">
                    <span className="dp-label">Will remain pending after dispatch:</span>
                    {d.orderedUnits > 0 && (
                      <span className={`dp-val ${d.pendingUnits - d.dispatchUnits > 0 ? 'pending' : 'dispatched'}`}>
                        {Math.max(0, d.pendingUnits - d.dispatchUnits)} units
                      </span>
                    )}
                    {d.orderedBoxes > 0 && (
                      <span className={`dp-val ${d.pendingBoxes - d.dispatchBoxes > 0 ? 'pending' : 'dispatched'}`}>
                        {Math.max(0, d.pendingBoxes - d.dispatchBoxes)} boxes
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Notes */}
            <div className="form-group" style={{ marginTop: 16 }}>
              <label className="form-label">Notes</label>
              <textarea
                className="form-input"
                value={notes}
                onChange={e => setNotes(e.target.value)}
                placeholder="Dispatch notes (optional)"
                rows={2}
              />
            </div>
          </div>

           {error && <p style={{color:'#dc3545',fontSize:13}}>{error}</p>}

          <div className="modal-footer">
            <button type="button" className="btn btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-update" disabled={submitting}>
              {submitting ? 'Dispatching...' : 'Confirm Dispatch'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DispatchModal;